module.exports = __webpack_public_path__ + "media/images/booking_promotion-7f9ee7880a4e2b0fcef53dcff8bb83a0.svg";